function emitDomMutation() {
  window.dispatchEvent(new CustomEvent("pm2:dom-mutation"));
}
function observeDomMutation(cb, options) {
  window.addEventListener("pm2:dom-mutation", cb, options);
  return () => {
    window.removeEventListener("pm2:dom-mutation", cb, options);
  };
}

export { emitDomMutation, observeDomMutation };
//# sourceMappingURL=events.dom-mutation.js.map
